import React, { useContext, useMemo, useState } from 'react';
import { Icon, Segment, TextArea } from 'semantic-ui-react';
import { FormContext } from '../../../cnr/contexts/FormContext';
import { uniqueKey } from '../../../common/keys';
import { renderHtml } from '../../html/renderHtml';

export const TextAreaToggle = (props) => {

  const { fip, prop } = props
  const { key, propname } = fip
  const className = (fip.required) ? 'field required' : 'field'
  const c = fip.label

  delete fip.key

  const formContext = useContext(FormContext)
  const { form_handlers, useDarkMode } = formContext ?? {}
  const { handleEditor } = form_handlers ?? {}

  const _handleEditor = props?.handleEditor || handleEditor

  const [showHtml, handleHtml] = useState(true)

  function removeExtraBreaks(html) {
    return html.replace(/(<br\s*\/?>\s*)+/g, '<br>');
  }

  const renderedHtml = useMemo(() => {
    try {
      const _html = fip.value ? removeExtraBreaks(fip.value) : fip.value
      return renderHtml(_html);
    } catch (error) {
      return fip.value;
    }
  }, [fip.value]);

  return (
    <div key={uniqueKey('tat', propname)} className={className}>
      <div className="field">
        <label style={{ float: 'left' }}>{c}</label>
      </div>
      <Icon
        key={uniqueKey('tat', propname, 1)}
        name="html5"
        style={{ marginBottom: 2 }}
        onClick={() => handleHtml((prev) => !prev)}
      />
      <Icon
        key={uniqueKey('tat', propname, 2)}
        name="edit outline"
        style={{ float: 'right', marginBottom: 2 }}
        onClick={() => _handleEditor({ ...fip, prop })}
      />
      {showHtml ? (
        <Segment inverted={useDarkMode} basic className="is-html">
          <div dangerouslySetInnerHTML={{ __html: renderedHtml }} />
        </Segment>
      ) : (
        <TextArea key={uniqueKey('tat', 'ht', propname, 4)} {...fip} rows={5} />
      )}
    </div>
  );

}

